<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <div class="flex justify-content-between align-items-center mb-4">
                    <h3>Gestione Depositi</h3>
                    <Button label="Nuovo Deposito" icon="pi pi-plus" @click="openDialog()" />
                </div>

                <DataTable :value="depositi" responsiveLayout="scroll" selectionMode="single" v-model:selection="selectedDeposito" @rowSelect="onRowSelect">
                    <Column field="nome" header="Nome"></Column>
                    <Column field="indirizzo" header="Indirizzo"></Column>
                    <Column field="descrizione" header="Descrizione"></Column>
                    <Column header="Azioni" :exportable="false" style="min-width:8rem">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="openDialog(slotProps.data)" />
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="confirmDelete(slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>

        <div class="col-12" v-if="selectedDeposito">
            <div class="card">
                <div class="flex justify-content-between align-items-center mb-3">
                    <h3>Giacenze: {{selectedDeposito.nome}}</h3>
                </div>
                <DataTable :value="giacenze" responsiveLayout="scroll" :loading="loadingGiacenze">
                    <Column field="nome_prodotto" header="Prodotto">
                        <template #body="slotProps">
                            <router-link :to="'/prodotto/' + slotProps.data.id_prodotto + '/dettagli'" class="font-bold text-primary hover:underline cursor-pointer" style="text-decoration: underline;">
                                {{ slotProps.data.nome_prodotto }}
                            </router-link>
                        </template>
                    </Column>
                    <Column field="quantita" header="Quantità Totale">
                        <template #body="slotProps">
                            <span 
                                class="p-tag p-tag-info cursor-pointer font-bold" 
                                style="font-size: 0.95rem; padding: 0.35rem 0.75rem; cursor: pointer;"
                                title="Clicca per allineare la giacenza complessiva"
                                @click="openAlignDialog(slotProps.data)"
                            >
                                {{ slotProps.data.quantita }} <i class="pi pi-pencil ml-2" style="font-size: 0.75rem;"></i>
                            </span>
                        </template>
                    </Column>
                    <Column header="Dettaglio Taglie & Azioni" style="min-width:14rem">
                        <template #body="slotProps">
                            <Button 
                                label="Dettagli Taglie" 
                                icon="pi pi-list" 
                                class="p-button-outlined p-button-sm p-button-info mr-2" 
                                @click="openDetailDialog(slotProps.data)"
                            />
                            <Button 
                                icon="pi pi-pencil" 
                                class="p-button-rounded p-button-success p-button-sm" 
                                title="Allinea Giacenza"
                                @click="openAlignDialog(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>

        <!-- Dialog Gestione Deposito -->
        <Dialog v-model:visible="depositoDialog" :style="{width: '450px'}" header="Dettagli Deposito" :modal="true" class="p-fluid">
            <div class="field">
                <label for="name">Nome</label>
                <InputText id="name" v-model="deposito.nome" required="true" autofocus :class="{'p-invalid': submitted && !deposito.nome}" />
                <small class="p-error" v-if="submitted && !deposito.nome">Nome è obbligatorio.</small>
            </div>
            <div class="field">
                <label for="indirizzo">Indirizzo</label>
                <InputText id="indirizzo" v-model="deposito.indirizzo" />
            </div>
            <div class="field">
                <label for="descrizione">Descrizione</label>
                <Textarea id="descrizione" v-model="deposito.descrizione" rows="3" />
            </div>
            <div class="field">
                <label for="responsabile">Responsabile</label>
                <Dropdown id="responsabile" v-model="deposito.id_responsabile" :options="staffOptions" optionLabel="label" optionValue="value" placeholder="Seleziona Responsabile" />
            </div>
            <template #footer>
                <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
                <Button label="Salva" icon="pi pi-check" class="p-button-text" @click="saveDeposito" />
            </template>
        </Dialog>

        <!-- Dialog Conferma Eliminazione -->
        <Dialog v-model:visible="deleteDepositoDialog" :style="{width: '450px'}" header="Conferma" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="deposito">Sei sicuro di voler eliminare <b>{{deposito.nome}}</b>?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteDepositoDialog = false" />
                <Button label="Sì" icon="pi pi-check" class="p-button-text" @click="deleteDeposito" />
            </template>
        </Dialog>

        <!-- Dialog Dettaglio Giacenze per Taglia -->
        <Dialog v-model:visible="detailDialog" :style="{width: '550px'}" header="Dettaglio Giacenza per Taglia" :modal="true" class="p-fluid">
            <div v-if="detailProduct" class="mb-3">
                <div class="flex justify-content-between align-items-center surface-100 p-3 border-round mb-3">
                    <div>
                        <h4 class="m-0 text-primary">{{ detailProduct.nome_prodotto }}</h4>
                        <small class="text-secondary">Deposito: {{ selectedDeposito ? selectedDeposito.nome : '' }}</small>
                    </div>
                    <div>
                        <span class="font-bold">Totale: </span>
                        <span class="p-tag p-tag-info font-bold text-base ml-1">{{ detailProduct.quantita }}</span>
                    </div>
                </div>

                <div v-if="detailProduct.taglie && detailProduct.taglie.length > 0">
                    <DataTable :value="detailProduct.taglie" responsiveLayout="scroll" class="p-datatable-sm">
                        <Column field="nome_taglia" header="Taglia">
                            <template #body="slotProps">
                                <span class="font-bold text-lg">{{ slotProps.data.nome_taglia }}</span>
                            </template>
                        </Column>
                        <Column field="quantita" header="Giacenza">
                            <template #body="slotProps">
                                <span :class="slotProps.data.quantita > 0 ? 'text-green-600 font-bold' : slotProps.data.quantita < 0 ? 'text-red-600 font-bold' : 'text-gray-500 font-bold'">
                                    {{ slotProps.data.quantita }}
                                </span>
                            </template>
                        </Column>
                        <Column header="Azioni" style="width: 100px">
                            <template #body="slotProps">
                                <Button 
                                    icon="pi pi-pencil" 
                                    class="p-button-rounded p-button-success p-button-sm" 
                                    title="Modifica / Allinea questa taglia"
                                    @click="openAlignDialog(detailProduct, slotProps.data)"
                                />
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div v-else class="text-center p-4 surface-50 border-round">
                    <i class="pi pi-inbox text-4xl text-400 mb-2"></i>
                    <p class="text-secondary m-0">Nessuna taglia specifica registrata per questo prodotto in questo deposito.</p>
                </div>

                <div class="mt-4 flex justify-content-end">
                    <Button 
                        label="Aggiungi / Allinea Nuova Taglia" 
                        icon="pi pi-plus" 
                        class="p-button-outlined p-button-sm p-button-primary" 
                        @click="openAlignDialog(detailProduct)"
                    />
                </div>
            </div>
            <template #footer>
                <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="detailDialog = false" />
            </template>
        </Dialog>

        <!-- Dialog Allineamento Giacenza -->
        <Dialog v-model:visible="alignDialog" :style="{width: '500px'}" header="Allinea Giacenza Magazzino" :modal="true" class="p-fluid">
            <div class="field mb-3" v-if="alignData.nome_prodotto">
                <label class="font-bold">Prodotto:</label>
                <div class="text-lg font-semibold text-primary">{{ alignData.nome_prodotto }}</div>
                <small class="text-secondary">Deposito: {{ selectedDeposito ? selectedDeposito.nome : '' }}</small>
            </div>

            <!-- Selezione Taglia -->
            <div class="field mb-3">
                <label for="cod_size" class="font-bold">Taglia:</label>
                <Dropdown 
                    id="cod_size" 
                    v-model="alignData.cod_size" 
                    :options="sizeOptions" 
                    optionLabel="label" 
                    optionValue="value" 
                    placeholder="Seleziona Taglia (oppure Totale)" 
                    class="w-full"
                    @change="onSizeChange"
                />
            </div>
            
            <div class="field mb-3">
                <label for="giacenza_attuale" class="font-bold">
                    Giacenza Attuale {{ selectedSizeLabel ? '(' + selectedSizeLabel + ')' : '(Totale)' }}:
                </label>
                <InputNumber id="giacenza_attuale" :modelValue="alignData.giacenza_attuale" disabled class="w-full" />
            </div>

            <div class="field mb-3">
                <label for="nuova_giacenza" class="font-bold">
                    Nuova Giacenza Reale {{ selectedSizeLabel ? '(' + selectedSizeLabel + ')' : '(Totale)' }}:
                </label>
                <InputNumber id="nuova_giacenza" v-model="alignData.nuova_giacenza" integeronly autofocus class="w-full" />
            </div>

            <!-- Calcolo variazione -->
            <div class="field mb-3 p-3 surface-100 border-round">
                <div class="flex justify-content-between align-items-center">
                    <span class="font-bold">Variazione Giacenza (Δ):</span>
                    <span :class="alignDelta > 0 ? 'text-green-600 font-bold text-lg' : alignDelta < 0 ? 'text-red-600 font-bold text-lg' : 'text-gray-500 font-bold'">
                        {{ alignDelta > 0 ? ('+' + alignDelta) : alignDelta }}
                    </span>
                </div>
                <small v-if="alignDelta > 0" class="text-green-600 block mt-1">
                    Verrà registrato un <b>movimento di acquisto (carico)</b> per +{{ alignDelta }} unità{{ selectedSizeLabel ? (' taglia ' + selectedSizeLabel) : '' }}.
                </small>
                <small v-else-if="alignDelta < 0" class="text-red-600 block mt-1">
                    Verrà registrato un <b>movimento di rettifica (scarico)</b> per {{ alignDelta }} unità{{ selectedSizeLabel ? (' taglia ' + selectedSizeLabel) : '' }}.
                </small>
            </div>

            <!-- Campo Opzionale Prezzo per delta > 0 -->
            <div class="field mb-3" v-if="alignDelta > 0">
                <label for="prezzo_acquisto" class="font-bold">Prezzo Totale Acquisto (€) <small class="text-secondary">(Opzionale)</small>:</label>
                <InputNumber id="prezzo_acquisto" v-model="alignData.prezzo" mode="currency" currency="EUR" locale="it-IT" placeholder="0.00" class="w-full" />
            </div>

            <!-- Campo Opzionale Nota per delta < 0 -->
            <div class="field mb-3" v-if="alignDelta < 0">
                <label for="note_scarico" class="font-bold">Nota / Motivazione Scarico <small class="text-secondary">(Opzionale)</small>:</label>
                <Textarea id="note_scarico" v-model="alignData.note" rows="3" placeholder="Es. Inventario, Merce danneggiata o resa..." class="w-full" />
            </div>

            <template #footer>
                <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="alignDialog = false" />
                <Button label="Conferma Allineamento" icon="pi pi-check" class="p-button-primary" :loading="alignLoading" :disabled="alignDelta === 0" @click="saveAllineamento" />
            </template>
        </Dialog>
    </div>
</template>

<script>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/levante-api/levante-api';
import { useToast } from 'primevue/usetoast';

export default {
    setup() {
        const self = getCurrentInstance();
        const eventBus = self.appContext.config.globalProperties.$eventBus;
        const service = new Service(eventBus);
        const toast = useToast();

        const depositi = ref([]);
        const giacenze = ref([]);
        const selectedDeposito = ref(null);
        const depositoDialog = ref(false);
        const deleteDepositoDialog = ref(false);
        const deposito = ref({});
        const submitted = ref(false);
        const loadingGiacenze = ref(false);
        const staffOptions = ref([]);

        // Taglie
        const sizesList = ref([]);
        const sizeOptions = computed(() => {
            const list = [{ label: 'Tutte / Giacenza Totale', value: null }];
            sizesList.value.forEach(s => {
                list.push({ label: s.nome, value: s.id });
            });
            return list;
        });

        // Dialog Dettagli Taglie
        const detailDialog = ref(false);
        const detailProduct = ref(null);

        // Dialog Allineamento Giacenza
        const alignDialog = ref(false);
        const alignLoading = ref(false);
        const alignProductRef = ref(null);
        const alignData = ref({
            id_prodotto: null,
            nome_prodotto: '',
            cod_size: null,
            giacenza_attuale: 0,
            nuova_giacenza: 0,
            prezzo: null,
            note: ''
        });

        const selectedSizeLabel = computed(() => {
            if (alignData.value.cod_size === null || alignData.value.cod_size === undefined || alignData.value.cod_size === '') return null;
            const found = sizesList.value.find(s => s.id == alignData.value.cod_size);
            return found ? found.nome : ('Taglia ID ' + alignData.value.cod_size);
        });

        const alignDelta = computed(() => {
            const val = (alignData.value.nuova_giacenza ?? 0) - (alignData.value.giacenza_attuale ?? 0);
            return isNaN(val) ? 0 : val;
        });

        const openDetailDialog = (row) => {
            detailProduct.value = row;
            detailDialog.value = true;
        };

        const openAlignDialog = (row, specificSize = null) => {
            alignProductRef.value = row;
            const sizeId = specificSize ? specificSize.cod_size : null;
            
            let currentQty = row.quantita;
            if (sizeId !== null && sizeId !== undefined) {
                const found = (row.taglie || []).find(t => t.cod_size == sizeId);
                currentQty = found ? found.quantita : 0;
            }

            alignData.value = {
                id_prodotto: row.id_prodotto,
                nome_prodotto: row.nome_prodotto,
                cod_size: sizeId,
                giacenza_attuale: parseInt(currentQty ?? 0),
                nuova_giacenza: parseInt(currentQty ?? 0),
                prezzo: null,
                note: ''
            };
            alignDialog.value = true;
        };

        const onSizeChange = () => {
            const row = alignProductRef.value;
            if (!row) return;

            let currentQty = row.quantita;
            if (alignData.value.cod_size !== null && alignData.value.cod_size !== undefined && alignData.value.cod_size !== '') {
                const found = (row.taglie || []).find(t => t.cod_size == alignData.value.cod_size);
                currentQty = found ? found.quantita : 0;
            }

            alignData.value.giacenza_attuale = parseInt(currentQty ?? 0);
            alignData.value.nuova_giacenza = parseInt(currentQty ?? 0);
        };

        const saveAllineamento = async () => {
            if (!selectedDeposito.value || alignDelta.value === 0) return;
            alignLoading.value = true;

            let fd = new FormData();
            fd.append('id_deposito', selectedDeposito.value.id);
            fd.append('id_prodotto', alignData.value.id_prodotto);
            fd.append('nuova_giacenza', alignData.value.nuova_giacenza);
            if (alignData.value.cod_size !== null && alignData.value.cod_size !== undefined && alignData.value.cod_size !== '') {
                fd.append('cod_size', alignData.value.cod_size);
            }
            if (alignData.value.prezzo !== null && alignData.value.prezzo !== undefined) {
                fd.append('prezzo', alignData.value.prezzo);
            }
            if (alignData.value.note) {
                fd.append('note', alignData.value.note);
            }

            try {
                const res = await service.allineaGiacenza(fd);
                const item = res.item || res.data || res.items || res;
                if (item.esito === 'success' || item.status === 'success') {
                    toast.add({ severity: 'success', summary: 'Successo', detail: item.messaggio || 'Giacenza allineata', life: 3000 });
                    alignDialog.value = false;
                    await loadGiacenze(selectedDeposito.value.id);

                    // Se il dialog dettagli è aperto, aggiorna i dati del prodotto selezionato
                    if (detailProduct.value) {
                        const updatedProd = giacenze.value.find(p => p.id_prodotto === detailProduct.value.id_prodotto);
                        if (updatedProd) {
                            detailProduct.value = updatedProd;
                        }
                    }
                } else {
                    toast.add({ severity: 'error', summary: 'Errore', detail: item.messaggio || 'Errore durante l\'allineamento', life: 3000 });
                }
            } catch (err) {
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile allineare la giacenza', life: 3000 });
            } finally {
                alignLoading.value = false;
            }
        };

        const loadDepositi = async () => {
            const res = await service.getDepositi();
            if (res.items.status === 'success') {
                depositi.value = res.items.data;
            }
        };

        const loadStaff = async () => {
            const res = await service.getAllStaff();
            if (res.items) {
                 staffOptions.value = res.items.map(s => ({
                     label: s.nome,
                     value: s.id
                 }));
            }
        };

        const loadSizes = async () => {
            try {
                const res = await service.getSizes();
                if (res.items) {
                    sizesList.value = res.items;
                }
            } catch (e) {
                console.error('Errore durante il caricamento delle taglie:', e);
            }
        };

        const loadGiacenze = async (id) => {
            loadingGiacenze.value = true;
            const res = await service.getGiacenzeDeposito(id);
            if (res.items.status === 'success') {
                giacenze.value = res.items.data;
            }
            loadingGiacenze.value = false;
        };

        onMounted(() => {
            loadDepositi();
            loadStaff();
            loadSizes();
        });

        const openDialog = (data) => {
            deposito.value = data ? { ...data } : {};
            submitted.value = false;
            depositoDialog.value = true;
        };

        const hideDialog = () => {
            depositoDialog.value = false;
            submitted.value = false;
        };

        const saveDeposito = async () => {
            submitted.value = true;
            if (deposito.value.nome && deposito.value.nome.trim()) {
                let fd = new FormData();
                if (deposito.value.id) fd.append('id', deposito.value.id);
                fd.append('nome', deposito.value.nome);
                fd.append('indirizzo', deposito.value.indirizzo || '');
                fd.append('descrizione', deposito.value.descrizione || '');
                fd.append('id_responsabile', deposito.value.id_responsabile || '');

                const res = await service.saveDeposito(fd);
                if (res.item.esito === 'success') {
                    toast.add({ severity: 'success', summary: 'Successo', detail: res.item.messaggio, life: 3000 });
                    depositoDialog.value = false;
                    deposito.value = {};
                    loadDepositi();
                } else {
                    toast.add({ severity: 'error', summary: 'Errore', detail: res.item.messaggio, life: 3000 });
                }
            }
        };

        const confirmDelete = (data) => {
            deposito.value = data;
            deleteDepositoDialog.value = true;
        };

        const deleteDeposito = async () => {
            try {
                const res = await service.deleteDeposito(deposito.value.id);
                if (res.data.esito === 'success') {
                    toast.add({ severity: 'success', summary: 'Successo', detail: res.data.messaggio, life: 3000 });
                    deleteDepositoDialog.value = false;
                    deposito.value = {};
                    selectedDeposito.value = null;
                    loadDepositi();
                } else {
                    toast.add({ severity: 'error', summary: 'Errore', detail: res.data.messaggio, life: 3000 });
                    deleteDepositoDialog.value = false;
                }
            } catch (err) {
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'eliminazione', life: 3000 });
            }
        };

        const onRowSelect = (event) => {
            loadGiacenze(event.data.id);
        };

        return {
            depositi,
            giacenze,
            selectedDeposito,
            depositoDialog,
            deleteDepositoDialog,
            deposito,
            submitted,
            loadingGiacenze,
            staffOptions,
            sizesList,
            sizeOptions,
            detailDialog,
            detailProduct,
            alignDialog,
            alignLoading,
            alignData,
            alignDelta,
            selectedSizeLabel,
            openDetailDialog,
            openAlignDialog,
            onSizeChange,
            saveAllineamento,
            openDialog,
            hideDialog,
            saveDeposito,
            confirmDelete,
            deleteDeposito,
            onRowSelect
        };
    }
}
</script>

